module.exports = __webpack_public_path__ + "img/impostor-bg-3.b0ecd7c5.webp";